import { Industry, SubIndustry } from "@cxm/client";

const subindustries = {
  "1": {
    "name": "Crop Production",
    "code": "111",
    subIndustry: SubIndustry.CROP_PRODUCTION,
    parent: 0,
  },
  "2": {
    "name": "Animal Production and Aquaculture",
    "code": "112",
    subIndustry: SubIndustry.ANIMAL_PRODUCTION_AND_AQUACULTURE,
    "parent": 0,
  },
  "3": {
    "name": "Forestry and Logging",
    subIndustry: SubIndustry.FORESTRY_AND_LOGGING,
    "code": "113",
    "parent": 0,
  },
  "4": {
    subIndustry: SubIndustry.FISHING_HUNTING_AND_TRAPPING,
    "name": "Fishing, Hunting and Trapping",
    "code": "114",
    "parent": 0,
  },
  "5": {
    subIndustry: SubIndustry.SUPPORT_ACTIVITIES_FOR_AGRICULTURE_AND_FORESTRY,
    "name": "Support Activities for Agriculture and Forestry",
    "code": "115",
    "parent": 0,
  },
  "6": {
    subIndustry: SubIndustry.OIL_AND_GAS_EXTRACTION,
    "name": "Oil and Gas Extraction",
    "code": "211",
    "parent": 1,
  },
  "7": {
    subIndustry: SubIndustry.MINING_EXCEPT_OIL_AND_GAS,
    "name": "Mining (except Oil and Gas)",
    "code": "212",
    "parent": 1,
  },
  "8": {
    subIndustry: SubIndustry.SUPPORT_ACTIVITIES_FOR_MINING,
    "name": "Support Activities for Mining",
    "code": "213",
    "parent": 1,
  },
  "9": {
    subIndustry: SubIndustry.UTILITIES,
    "name": "Utilities",
    "code": "221",
    "parent": 2,
  },
  "10": {
    subIndustry: SubIndustry.CONSTRUCTION_OF_BUILDINGS,
    "name": "Construction of Buildings",
    "code": "236",
    "parent": 3,
  },
  "11": {
    subIndustry: SubIndustry.HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION,
    "name": "Heavy and Civil Engineering Construction",
    "code": "237",
    "parent": 3,
  },
  "12": {
    subIndustry: SubIndustry.SPECIALTY_TRADE_CONTRACTORS,
    "name": "Specialty Trade Contractors",
    "code": "238",
    "parent": 3,
  },
  "13": {
    subIndustry: SubIndustry.FOOD_MANUFACTURING,
    "name": "Food Manufacturing",
    "code": "311",
    "parent": 4,
  },
  "14": {
    subIndustry: SubIndustry.BEVERAGE_AND_TOBACCO_PRODUCT_MANUFACTURING,
    "name": "Beverage and Tobacco Product Manufacturing",
    "code": "312",
    "parent": 4,
  },
  "15": {
    subIndustry: SubIndustry.TEXTILE_MILLS,
    "name": "Textile Mills",
    "code": "313",
    "parent": 4,
  },
  "16": {
    subIndustry: SubIndustry.TEXTILE_PRODUCT_MILLS,
    "name": "Textile Product Mills",
    "code": "314",
    "parent": 4,
  },
  "17": {
    subIndustry: SubIndustry.APPAREL_MANUFACTURING,
    "name": "Apparel Manufacturing",
    "code": "315",
    "parent": 4,
  },
  "18": {
    subIndustry: SubIndustry.LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING,
    "name": "Leather and Allied Product Manufacturing",
    "code": "316",
    "parent": 4,
  },
  "19": {
    subIndustry: SubIndustry.WOOD_PRODUCT_MANUFACTURING,
    "name": "Wood Product Manufacturing",
    "code": "321",
    "parent": 4,
  },
  "20": {
    subIndustry: SubIndustry.PAPER_MANUFACTURING,
    "name": "Paper Manufacturing",
    "code": "322",
    "parent": 4,
  },
  "21": {
    subIndustry: SubIndustry.PRINTING_AND_RELATED_SUPPORT_ACTIVITIES,
    "name": "Printing and Related Support Activities",
    "code": "323",
    "parent": 4,
  },
  "22": {
    subIndustry: SubIndustry.PETROLEUM_AND_COAL_PRODUCTS_MANUFACTURING,
    "name": "Petroleum and Coal Products Manufacturing",
    "code": "324",
    "parent": 4,
  },
  "23": {
    subIndustry: SubIndustry.CHEMICAL_MANUFACTURING,
    "name": "Chemical Manufacturing",
    "code": "325",
    "parent": 4,
  },
  "24": {
    subIndustry: SubIndustry.PLASTICS_AND_RUBBER_PRODUCTS_MANUFACTURING,
    "name": "Plastics and Rubber Products Manufacturing",
    "code": "326",
    "parent": 4,
  },
  "25": {
    subIndustry: SubIndustry.NONMETALLIC_MINERAL_PRODUCT_MANUFACTURING,
    "name": "Nonmetallic Mineral Product Manufacturing",
    "code": "327",
    "parent": 4,
  },
  "26": {
    subIndustry: SubIndustry.PRIMARY_METAL_MANUFACTURING,
    "name": "Primary Metal Manufacturing",
    "code": "331",
    "parent": 4,
  },
  "27": {
    subIndustry: SubIndustry.FABRICATED_METAL_PRODUCT_MANUFACTURING,
    "name": "Fabricated Metal Product Manufacturing",
    "code": "332",
    "parent": 4,
  },
  "28": {
    subIndustry: SubIndustry.MACHINERY_MANUFACTURING,
    "name": "Machinery Manufacturing",
    "code": "333",
    "parent": 4,
  },
  "29": {
    "name": "Computer and Electronic Product Manufacturing",
    subIndustry: SubIndustry.COMPUTER_AND_ELECTRONIC_PRODUCT_MANUFACTURING,
    "code": "334",
    "parent": 4,
  },
  "30": {
    subIndustry:
      SubIndustry.ELECTRICAL_EQUIPMENT_APPLIANCE_AND_COMPONENT_MANUFACTURING,
    "name": "Electrical Equipment, Appliance, and Component Manufacturing",
    "code": "335",
    "parent": 4,
  },
  "31": {
    subIndustry: SubIndustry.TRANSPORTATION_EQUIPMENT_MANUFACTURING,
    "name": "Transportation Equipment Manufacturing",
    "code": "336",
    "parent": 4,
  },
  "32": {
    subIndustry: SubIndustry.FURNITURE_AND_RELATED_PRODUCT_MANUFACTURING,
    "name": "Furniture and Related Product Manufacturing",
    "code": "337",
    "parent": 4,
  },
  "33": {
    subIndustry: SubIndustry.MISCELLANEOUS_MANUFACTURING,
    "name": "Miscellaneous Manufacturing",
    "code": "339",
    "parent": 4,
  },
  "34": {
    subIndustry: SubIndustry.MERCHANT_WHOLESALERS_DURABLE_GOODS,
    "name": "Merchant Wholesalers, Durable Goods",
    "code": "423",
    "parent": 5,
  },
  "35": {
    subIndustry: SubIndustry.MERCHANT_WHOLESALERS_NONDURABLE_GOODS,
    "name": "Merchant Wholesalers, Nondurable Goods",
    "code": "424",
    "parent": 5,
  },
  "36": {
    subIndustry:
      SubIndustry.WHOLESALE_ELECTRONIC_MARKETS_AND_AGENTS_AND_BROKERS,
    "name": "Wholesale Electronic Markets and Agents and Brokers",
    "code": "425",
    "parent": 5,
  },
  "37": {
    subIndustry: SubIndustry.MOTOR_VEHICLE_AND_PARTS_DEALERS,
    "name": "Motor Vehicle and Parts Dealers",
    "code": "441",
    "parent": 6,
  },
  "38": {
    "name": "Furniture and Home Furnishings Stores",
    subIndustry: SubIndustry.FURNITURE_AND_HOME_FURNISHINGS_STORES,
    "code": "442",
    "parent": 6,
  },
  "39": {
    subIndustry: SubIndustry.ELECTRONICS_AND_APPLIANCE_STORES,
    "name": "Electronics and Appliance Stores",
    "code": "443",
    "parent": 6,
  },
  "40": {
    subIndustry:
      SubIndustry.BUILDING_MATERIAL_AND_GARDEN_EQUIPMENT_AND_SUPPLIES_DEALERS,
    "name": "Building Material and Garden Equipment and Supplies Dealers",
    "code": "444",
    "parent": 6,
  },
  "41": {
    subIndustry: SubIndustry.FOOD_AND_BEVERAGE_STORES,
    "name": "Food and Beverage Stores",
    "code": "445",
    "parent": 6,
  },
  "42": {
    subIndustry: SubIndustry.HEALTH_AND_PERSONAL_CARE_STORES,
    "name": "Health and Personal Care Stores",
    "code": "446",
    "parent": 6,
  },
  "43": {
    subIndustry: SubIndustry.GASOLINE_STATIONS,
    "name": "Gasoline Stations",
    "code": "447",
    "parent": 6,
  },
  "44": {
    subIndustry: SubIndustry.CLOTHING_AND_CLOTHING_ACCESSORIES_STORES,
    "name": "Clothing and Clothing Accessories Stores",
    "code": "448",
    "parent": 6,
  },
  "45": {
    subIndustry:
      SubIndustry.SPORTING_GOODS_HOBBY_MUSICAL_INSTRUMENT_AND_BOOK_STORES,
    "name": "Sporting Goods, Hobby, Musical Instrument, and Book Stores",
    "code": "451",
    "parent": 6,
  },
  "46": {
    subIndustry: SubIndustry.GENERAL_MERCHANDISE_STORES,
    "name": "General Merchandise Stores",
    "code": "452",
    "parent": 6,
  },
  "47": {
    subIndustry: SubIndustry.MISCELLANEOUS_STORE_RETAILERS,
    "name": "Miscellaneous Store Retailers",
    "code": "453",
    "parent": 6,
  },
  "48": {
    subIndustry: SubIndustry.NONSTORE_RETAILERS,
    "name": "Nonstore Retailers",
    "code": "454",
    "parent": 6,
  },
  "49": {
    subIndustry: SubIndustry.AIR_TRANSPORTATION,
    "name": "Air Transportation",
    "code": "481",
    "parent": 7,
  },
  "50": {
    subIndustry: SubIndustry.RAIL_TRANSPORTATION,
    "name": "Rail Transportation",
    "code": "482",
    "parent": 7,
  },
  "51": {
    subIndustry: SubIndustry.WATER_TRANSPORTATION,
    "name": "Water Transportation",
    "code": "483",
    "parent": 7,
  },
  "52": {
    subIndustry: SubIndustry.TRUCK_TRANSPORTATION,
    "name": "Truck Transportation",
    "code": "484",
    "parent": 7,
  },
  "53": {
    subIndustry: SubIndustry.TRANSIT_AND_GROUND_PASSENGER_TRANSPORTATION,
    "name": "Transit and Ground Passenger Transportation",
    "code": "485",
    "parent": 7,
  },
  "54": {
    subIndustry: SubIndustry.PIPELINE_TRANSPORTATION,
    "name": "Pipeline Transportation",
    "code": "486",
    "parent": 7,
  },
  "55": {
    subIndustry: SubIndustry.SCENIC_AND_SIGHTSEEING_TRANSPORTATION,
    "name": "Scenic and Sightseeing Transportation",
    "code": "487",
    "parent": 7,
  },
  "56": {
    subIndustry: SubIndustry.SUPPORT_ACTIVITIES_FOR_TRANSPORTATION,
    "name": "Support Activities for Transportation",
    "code": "488",
    "parent": 7,
  },
  "57": {
    subIndustry: SubIndustry.POSTAL_SERVICE,
    "name": "Postal Service",
    "code": "491",
    "parent": 7,
  },
  "58": {
    subIndustry: SubIndustry.COURIERS_AND_MESSENGERS,
    "name": "Couriers and Messengers",
    "code": "492",
    "parent": 7,
  },
  "59": {
    subIndustry: SubIndustry.WAREHOUSING_AND_STORAGE,
    "name": "Warehousing and Storage",
    "code": "493",
    "parent": 7,
  },
  "60": {
    subIndustry: SubIndustry.PUBLISHING_INDUSTRIES_EXCEPT_INTERNET,
    "name": "Publishing Industries (except Internet)",
    "code": "511",
    "parent": 8,
  },
  "61": {
    "name": "Motion Picture and Sound Recording Industries",
    subIndustry: SubIndustry.MOTION_PICTURE_AND_SOUND_RECORDING_INDUSTRIES,
    "code": "512",
    "parent": 8,
  },
  "62": {
    subIndustry: SubIndustry.BROADCASTING_EXCEPT_INTERNET,
    "name": "Broadcasting (except Internet)",
    "code": "515",
    "parent": 8,
  },
  "63": {
    subIndustry: SubIndustry.TELECOMMUNICATIONS,
    "name": "Telecommunications",
    "code": "517",
    "parent": 8,
  },
  "64": {
    subIndustry: SubIndustry.DATA_PROCESSING_HOSTING_AND_RELATED_SERVICES,
    "name": "Data Processing, Hosting, and Related Services",
    "code": "518",
    "parent": 8,
  },
  "65": {
    subIndustry: SubIndustry.OTHER_INFORMATION_SERVICES,
    "name": "Other Information Services",
    "code": "519",
    "parent": 8,
  },
  "66": {
    subIndustry: SubIndustry.MONETARY_AUTHORITIES_CENTRAL_BANK,
    "name": "Monetary Authorities-Central Bank",
    "code": "521",
    "parent": 9,
  },
  "67": {
    subIndustry: SubIndustry.CREDIT_INTERMEDIATION_AND_RELATED_ACTIVITIES,
    "name": "Credit Intermediation and Related Activities",
    "code": "522",
    "parent": 9,
  },
  "68": {
    subIndustry: SubIndustry
      .SECURITIES_COMMODITY_CONTRACTS_AND_OTHER_FINANCIAL_INVESTMENTS_AND_RELATED_ACTIVITIES,
    "name":
      "Securities, Commodity Contracts, and Other Financial Investments and Related Activities",
    "code": "523",
    "parent": 9,
  },
  "69": {
    subIndustry: SubIndustry.INSURANCE_CARRIERS_AND_RELATED_ACTIVITIES,
    "name": "Insurance Carriers and Related Activities",
    "code": "524",
    "parent": 9,
  },
  "70": {
    subIndustry: SubIndustry.FUNDS_TRUSTS_AND_OTHER_FINANCIAL_VEHICLES,
    "name": "Funds, Trusts, and Other Financial Vehicles",
    "code": "525",
    "parent": 9,
  },
  "71": {
    subIndustry: SubIndustry.REAL_ESTATE,
    "name": "Real Estate",
    "code": "531",
    "parent": 10,
  },
  "72": {
    subIndustry: SubIndustry.RENTAL_AND_LEASING_SERVICES,
    "name": "Rental and Leasing Services",
    "code": "532",
    "parent": 10,
  },
  "73": {
    subIndustry: SubIndustry
      .LESSORS_OF_NONFINANCIAL_INTANGIBLE_ASSETS_EXCEPT_COPYRIGHTED_WORKS,
    "name":
      "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
    "code": "533",
    "parent": 10,
  },
  "74": {
    subIndustry: SubIndustry.PROFESSIONAL_SCIENTIFIC_AND_TECHNICAL_SERVICES,
    "name": "Professional, Scientific, and Technical Services",
    "code": "541",
    "parent": 11,
  },
  "75": {
    subIndustry: SubIndustry.MANAGEMENT_OF_COMPANIES_AND_ENTERPRISES,
    "name": "Management of Companies and Enterprises",
    "code": "551",
    "parent": 12,
  },
  "76": {
    subIndustry: SubIndustry.ADMINISTRATIVE_AND_SUPPORT_SERVICES,
    "name": "Administrative and Support Services",
    "code": "561",
    "parent": 13,
  },
  "77": {
    subIndustry: SubIndustry.WASTE_MANAGEMENT_AND_REMEDIATION_SERVICES,
    "name": "Waste Management and Remediation Services",
    "code": "562",
    "parent": 13,
  },
  "78": {
    subIndustry: SubIndustry.EDUCATIONAL_SERVICES,
    "name": "Educational Services",
    "code": "611",
    "parent": 14,
  },
  "79": {
    subIndustry: SubIndustry.AMBULATORY_HEALTH_CARE_SERVICES,
    "name": "Ambulatory Health Care Services",
    "code": "621",
    "parent": 15,
  },
  "80": {
    subIndustry: SubIndustry.HOSPITALS,
    "name": "Hospitals",
    "code": "622",
    "parent": 15,
  },
  "81": {
    subIndustry: SubIndustry.NURSING_AND_RESIDENTIAL_CARE_FACILITIES,
    "name": "Nursing and Residential Care Facilities",
    "code": "623",
    "parent": 15,
  },
  "82": {
    subIndustry: SubIndustry.SOCIAL_ASSISTANCE,
    "name": "Social Assistance",
    "code": "624",
    "parent": 15,
  },
  "83": {
    subIndustry:
      SubIndustry.PERFORMING_ARTS_SPECTATOR_SPORTS_AND_RELATED_INDUSTRIES,
    "name": "Performing Arts, Spectator Sports, and Related Industries",
    "code": "711",
    "parent": 16,
  },
  "84": {
    subIndustry: SubIndustry.MUSEUMS_HISTORICAL_SITES_AND_SIMILAR_INSTITUTIONS,
    "name": "Museums, Historical Sites, and Similar Institutions",
    "code": "712",
    "parent": 16,
  },
  "85": {
    subIndustry: SubIndustry.AMUSEMENT_GAMBLING_AND_RECREATION_INDUSTRIES,
    "name": "Amusement, Gambling, and Recreation Industries",
    "code": "713",
    "parent": 16,
  },
  "86": {
    subIndustry: SubIndustry.ACCOMMODATION,
    "name": "Accommodation",
    "code": "721",
    "parent": 17,
  },
  "87": {
    subIndustry: SubIndustry.FOOD_SERVICES_AND_DRINKING_PLACES,
    "name": "Food Services and Drinking Places",
    "code": "722",
    "parent": 17,
  },
  "88": {
    subIndustry: SubIndustry.REPAIR_AND_MAINTENANCE,
    "name": "Repair and Maintenance",
    "code": "811",
    "parent": 18,
  },
  "89": {
    subIndustry: SubIndustry.PERSONAL_AND_LAUNDRY_SERVICES,
    "name": "Personal and Laundry Services",
    "code": "812",
    "parent": 18,
  },
  "90": {
    subIndustry: SubIndustry
      .RELIGIOUS_GRANTMAKING_CIVIC_PROFESSIONAL_AND_SIMILAR_ORGANIZATIONS,
    "name":
      "Religious, Grantmaking, Civic, Professional, and Similar Organizations",
    "code": "813",
    "parent": 18,
  },
  "91": {
    subIndustry: SubIndustry.PRIVATE_HOUSEHOLDS,
    "name": "Private Households",
    "code": "814",
    "parent": 18,
  },
  "92": {
    subIndustry:
      SubIndustry.EXECUTIVE_LEGISLATIVE_AND_OTHER_GENERAL_GOVERNMENT_SUPPORT,
    "name": "Executive, Legislative, and Other General Government Support",
    "code": "921",
    "parent": 19,
  },
  "93": {
    subIndustry: SubIndustry.JUSTICE_PUBLIC_ORDER_AND_SAFETY_ACTIVITIES,
    "name": "Justice, Public Order, and Safety Activities",
    "code": "922",
    "parent": 19,
  },
  "94": {
    subIndustry: SubIndustry.ADMINISTRATION_OF_HUMAN_RESOURCE_PROGRAMS,
    "name": "Administration of Human Resource Programs",
    "code": "923",
    "parent": 19,
  },
  "95": {
    subIndustry: SubIndustry.ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_PROGRAMS,
    "name": "Administration of Environmental Quality Programs",
    "code": "924",
    "parent": 19,
  },
  "96": {
    subIndustry: SubIndustry
      .ADMINISTRATION_OF_HOUSING_PROGRAMS_URBAN_PLANNING_AND_COMMUNITY_DEVELOPMENT,
    "name":
      "Administration of Housing Programs, Urban Planning, and Community Development",
    "code": "925",
    "parent": 19,
  },
  "97": {
    subIndustry: SubIndustry.ADMINISTRATION_OF_ECONOMIC_PROGRAMS,
    "name": "Administration of Economic Programs",
    "code": "926",
    "parent": 19,
  },
  "98": {
    subIndustry: SubIndustry.SPACE_RESEARCH_AND_TECHNOLOGY,
    "name": "Space Research and Technology",
    "code": "927",
    "parent": 19,
  },
  "99": {
    subIndustry: SubIndustry.NATIONAL_SECURITY_AND_INTERNATIONAL_AFFAIRS,
    "name": "National Security and International Affairs",
    "code": "928",
    "parent": 19,
  },
  "100": {
    subIndustry: SubIndustry.COMPUTER_SYSTEMS_DESIGN_AND_RELATED_SERVICES,
    "name": "Computer Systems Design And Related Services",
    "code": "541",
    "parent": 8,
  },
};
export default subindustries;
